import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/scene-ready-dummy.png'


const _withScopeId = n => (_pushScopeId("data-v-709e0065"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "photopage" }
const _hoisted_2 = { id: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { id: "header__title" }, "Ga klaar staan.", -1))
const _hoisted_4 = { id: "content" }
const _hoisted_5 = {
  key: 0,
  id: "timer"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_7 = { id: "actions" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { id: "camera-icon" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_webcam_live_feed = _resolveComponent("webcam-live-feed")!
  const _component_submit_button = _resolveComponent("submit-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", {
        id: "header__subtitle",
        class: _normalizeClass({active: !!_ctx.timerIntance})
      }, "De foto wordt over " + _toDisplayString(_ctx.remaingTimeInSeconds) + " seconden genomen.", 3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (!!_ctx.timerIntance)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", {
              id: "timer-foreground",
              style: _normalizeStyle(`--duration: ${_ctx.timerLength}ms`)
            }, null, 4)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_webcam_live_feed, {
        id: "live-feed",
        width: 1920,
        height: 1080,
        framerate: 60,
        onReady: _ctx.onVideoReady
      }, null, 8, ["onReady"]),
      _hoisted_6
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_submit_button, {
        disabled: !_ctx.canTakePicture,
        onClick: _ctx.onPhotoButtonPressed
      }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ])
  ]))
}